module.exports = __webpack_public_path__ + "static/media/dan.7908794e.jpeg";